import React, { useEffect, useState } from 'react';
import SideBar from '../../SideBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faSpinner, faTimesCircle, faDownload, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import useAxiosPrivateSAI from '../../../hooks/useAxiosPrivateSAI';
import useAuth from '../../../hooks/useAuth';
import {toast} from 'sonner'

const MessagingCenter = () => {
  const axios = useAxiosPrivateSAI()
  const { auth } = useAuth()
  const [input, setInput] = useState('')
  const [open, setOpen] = useState(false)
  const [comms, setComms] = useState([])
  const [messages, setMessages] = useState([])
  const [activeCommId, setActiveCommId] = useState(null)
  const [activeCommSubject, setActiveCommSubject] = useState('')
  const [isLoadingMessages, setIsLoadingMessages] = useState(false)
  const [attachments, setAttachments] = useState([])
  const [selectedFilter, setSelectedFilter] = useState('All')
  const [isUploading, setIsUploading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const openSideout = () => {
    setOpen(true)
  }

  useEffect(() => {
    getComms()
  }, [])

  const filterKey = (filter) => {
    const map = {
      'All': null,
      'Policy': 'policy',
      'Claims': 'claim',
      'Quote': 'quote',
      'Multi Quote': 'multiquote',
      'Invoice': 'invoice',
      'OB': 'ob'
    };
    return map[filter]
  }  

  const getComms = async () => {
    setIsLoading(true)
    try {
      const { data } = await axios.get(
        '/api/communications/comm_types/545767b0-ff68-11eb-99d2-ede611c3a12d/academy',
        { params: { filter: '' } }
      )
      setComms(data ?? [])
    } catch (err) {
      toast.error('Failed to load messages')
      console.error(err);
      setComms([])
    } finally {
      setIsLoading(false)
    }
  }

  const getCommsThread = (commId, subject) => {
    setActiveCommId(commId);
    setActiveCommSubject(subject);
    setIsLoadingMessages(true);
  
    axios
      .get(`/api/messages/by_thread/${commId}`)
      .then((response) => {
        const msgs = response.data.messages || []
        const sortedMsgs = msgs.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
        console.log(sortedMsgs);

        setMessages(sortedMsgs)
      })
      .catch((error) => {
        toast.error(error)
        setMessages([])
      })
      .finally(() => {
        setIsLoadingMessages(false);
      })
  }  

  const sendComm = () => {
    console.log(activeCommId)
    if (!activeCommId || !input.trim()) {
      toast.error('No active communication or message body is empty.');
      return;
    }
  
    const formData = new FormData();
    formData.append('communication_id', activeCommId);
    formData.append('message_body', `<p>${input}</p>`);
    formData.append('message_title', activeCommSubject || 'New message');
    formData.append('role', 3);
    formData.append('recipients', JSON.stringify([]));
    formData.append('ccList', JSON.stringify([]));
  
    attachments.forEach((file) => {
      formData.append('files[]', file);
    });
  
    axios
      .post('/api/messages/submit', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        toast.success('Message sent:', response.data)
        setInput('');
        setAttachments([]);
        getCommsThread(activeCommId, activeCommSubject)
      })
      .catch((error) => {
        toast.error('Error sending message:', error);
      })
  }  

  const filteredComms = selectedFilter === 'All'
  ? comms
  : comms.filter(comm => comm.communication_area?.toLowerCase() === filterKey(selectedFilter))

  return (
    <div className="w-full">
    <div className="mb-8">
      <h3 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white text-center pt-6">
        Messaging Center
      </h3>
      <h4 className="text-lg font-medium text-white text-center">
        Welcome to your Staff Absence Portal. Here you can keep up to date with your communications.
      </h4>
    </div>
    {/* Main Content Layout */}
    <div className="flex flex-col lg:flex-row max-w-[90rem] mx-auto lg:space-x-6 mt-24">
      {/* Sidebar Card */}
      <SideBar active={'Messaging Center'} />
      {/* Main Card Section */}
      <main className="w-full lg:w-4/5 space-y-4">
        <div className="flex h-full w-full  rounded-md shadow-md text-sas-dark overflow-y-scroll">
        {/* Sidebar */}
        <aside className="w-1/4 border-r border-[#B9B9CA] p-4 bg-white h-screen overflow-y-scroll">
          <div className="flex justify-between items-center mb-2">
            <h2 className="text-xl font-bold">Chats</h2>
          </div>
          <div className="flex items-center space-x-1 border-b border-[#B9B9CA] overflow-x-auto py-2">
            {['All', 'Policy', 'Claims', 'Quote', 'Multi Quote', 'Invoice', 'OB'].map((filter) => (
              <div
                key={filter}
                onClick={() => setSelectedFilter(filter)}
                className={`whitespace-nowrap rounded-full py-1 px-2.5 cursor-pointer ${
                  selectedFilter === filter ? 'bg-sas text-white' : 'hover:bg-sas'
                }`}
              >
                {filter}
              </div>
            ))}
          </div>
          <ul className="">
            {isLoading ? (
              <div className="flex items-center justify-center p-4 text-sas-dark">
                <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
                <span>Loading messages...</span>
              </div>
            ) : filteredComms.length === 0 ? (
              <div className="flex items-center justify-center p-4 text-sas-dark">
                <span>No Messages Found</span>
              </div>
            ) : (
              filteredComms.map((comm) => (
                <div key={comm.communication_id} className="border-b border-[#B9B9CA]">
                  <li
                    className={`p-3 rounded-lg cursor-pointer my-1 ${
                      activeCommId === comm.communication_id ? 'bg-sas' : 'hover:bg-sas'
                    }`}
                    onClick={() =>
                      getCommsThread(comm.communication_id, comm.communication_subject)
                    }
                  >
                    <p className="font-semibold">{comm.communication_subject}</p>
                    <p className="text-sm text-sas-dark truncate">
                      {comm.communication_reference}
                    </p>
                  </li>
                </div>
              ))
            )}
          </ul>
        </aside>

        {/* Chat Section */}
        <section className="w-3/4">
              <header className="flex bg-white items-center justify-between p-4 border-b border-[#B9B9CA]">
                <div>
                  <h3 className="text-lg font-semibold">{activeCommSubject || 'Select a conversation'}</h3>
                </div>
              </header>

              <div className="flex-1 bg-white/75 p-6 space-y-4 overflow-y-auto w-full max-h-[80vh] min-h-[80vh] ">
                {isLoadingMessages ? (
                  <div className="flex justify-center items-center h-full text-gray-500">
                    <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                  </div>
                ) : messages.length > 0 ? (
                  messages.map((msg, idx) => {
                    const userEmail = auth?.user?.contact_email;
                    const isMine = msg.mg_from === userEmail;

                    return (
                      <div
                        key={msg.message_id || idx}
                        className={`max-w-2xl ${isMine ? 'ml-auto text-right' : 'text-left'}`}
                      >
                        <div
                          className={`text-sm leading-relaxed p-4 rounded-lg ${
                            isMine ? 'bg-gray-200 text-black' : 'bg-sas-dark text-white'
                          }`}
                          dangerouslySetInnerHTML={{ __html: msg.message_body }}
                        />

                        <div className={`flex ${isMine ? 'justify-end' : 'justify-between'} items-start mt-1`}>
                          {/* Attachment section */}
                          {Array.isArray(msg.message_attachments) && msg.message_attachments.length > 0 && (
                            <div className="flex flex-wrap">
                              {msg.message_attachments.map((attachment) => (
                                <a
                                  href={attachment.file_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  key={attachment.id}
                                  title="Download"
                                  className={`flex items-center justify-between px-3 py-2 rounded-md text-xs mb-1 mr-1 ${
                                    isMine ? 'bg-gray-300 text-black' : 'bg-sas text-white'
                                  }`}
                                >
                                  <span className="truncate pr-2">{attachment.filename}</span>
                                  <FontAwesomeIcon
                                    icon={faDownload}
                                    className={`${isMine ? 'text-black' : 'text-white'} cursor-pointer`}
                                  />
                                </a>
                              ))}
                            </div>
                          )}

                          <div className={`text-xs ${isMine ? 'text-gray-600 ml-2' : 'text-sas-dark'}`}>
                            {new Date(msg.created_at).toLocaleString()}
                          </div>
                        </div>
                      </div>
                  )})
                ) : (
                  <p className="text-center text-gray-500">
                    {activeCommId ? 'No messages yet for this thread.' : 'Select a chat to view messages.'}
                  </p>
                )}
              </div>
              <footer className="p-4 border-t border-[#B9B9CA]">
                <div className="flex items-center bg-white border rounded-full px-4 py-2">
                  <input
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        sendComm();
                      }
                    }}
                    placeholder="Write a message..."
                    className="flex-1 bg-transparent text-black placeholder-gray-400 outline-none px-2"
                  />
                  <div className='space-x-3'>
                    <input
                      type="file"
                      id="file-upload"
                      multiple
                      className="hidden"
                      onChange={(e) => {
                        setIsUploading(true)
                        setTimeout(() => {
                          setAttachments([...attachments, ...e.target.files])
                          setIsUploading(false)
                        }, 300)
                      }}
                    />
                    <label htmlFor="file-upload" className="cursor-pointer">
                      {isUploading ? 
                        <FontAwesomeIcon icon={faSpinner} spin /> : 
                      (
                        <FontAwesomeIcon icon={faPaperclip} className="text-sas" title="Attach file(s)" />
                      )}
                    </label>

                    <FontAwesomeIcon
                      icon={faPaperPlane}
                      className={`text-sas cursor-pointer ${
                        !input.trim() || !activeCommId ? 'opacity-50 cursor-not-allowed' : ''
                      }`}
                      onClick={() => {
                        if (input.trim() && activeCommId) {
                          sendComm()
                        }
                      }}
                    />
                  </div>
                </div>
                {attachments.length > 0 && (
                  <div className="mt-2 text-sm text-sas-dark flex items-center space-x-4">
                    {attachments.map((file, idx) => (
                      <div key={idx} className="flex items-center">
                        <span>{file.name}</span>
                        <FontAwesomeIcon
                          icon={faTimesCircle}
                          className="text-red-500 cursor-pointer ml-2"
                          onClick={() => {
                            const updated = attachments.filter((_, i) => i !== idx);
                            setAttachments(updated);
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </footer>
            </section>
        </div>
      </main>
    </div>
  </div>
  );
}

export default MessagingCenter